import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmbryoService } from 'src/app/Services/Embryo.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-installment-plans',
  templateUrl: './installment-plans.component.html',
  styleUrls: ['./installment-plans.component.scss'],
})
export class InstallmentPlansComponent implements OnInit {
  lang: any;
  installmentPlans: any[];

  constructor(
    private router: Router,
    private embryoService: EmbryoService,
    private translate: TranslateService
  ) {
    embryoService.emitLang.subscribe((lang: string) => {
      this.lang = lang;
      translate.setDefaultLang(lang);
    });
    this.installmentPlans = [
      {
        image: 'assets/images/valu-installment.png',
        alt: 'valu',
        installment_ar: 'قسط على 6 شهر بدون فوائد-',
        installment_en: '-Installment over 6 months without interest',
        payment_ar: 'قم بأختيار وسيلة الدفع فاليو عند اختيار طريقة الدفع -',
        payment_en: '-Select payment method ValU at checkout',
      },
      {
        image: 'assets/images/premium-installment.png',
        alt: 'Premium Card',
        installment_ar: 'قسط على 10 شهر بدون فوائد-',
        installment_en: '-Installment over 10 months without interest',
        payment_ar: 'قم بأختيار وسيلة الدفع بريميوم عند اختيار طريقة الدفع -',
        payment_en: '-Select payment method Premium at checkout',
      },
      {
        image: 'assets/images/emirates-installment.png',
        alt: 'Emirates NBD',
        installment_ar: 'قسط على 12 شهر بدون فوائد-',
        installment_en: '-Installment over 12 months without interest',
        payment_ar:
          'قم بأختيار الدفع تقسيط ببطاقة الأتمان عند اختيار طريقة الدفع -',
        payment_en:
          '-Select payment method Credit card installment at checkout',
      },
      {
        image: 'assets/images/audi-installment.png',
        alt: 'Bank Audi',
        installment_ar: 'قسط على 12 شهر بدون فوائد-',
        installment_en: '-Installment over 12 months without interest',
        payment_ar:
          'قم بأختيار الدفع تقسيط ببطاقة الأتمان عند اختيار طريقة الدفع -',
        payment_en:
          '-Select payment method Credit card installment at checkout',
      },
      {
        image: 'assets/images/shahry-installment.png',
        alt: 'Shahry',
        installment_ar: 'قسط على 18 شهر بدون فوائد -',
        installment_en: '-Installment over 18 Months without interest	',
        payment_ar: 'قم بأختيار وسيلة الدفع شهري عند اختيار طريقة الدفع -',
        payment_en: '-Select payment method Shahry at checkout',
      },
      {
        image: 'assets/images/sohoola-installment.png',
        alt: 'Souhoola',
        installment_ar: 'قسط على 12 شهر بدون فوائد -',
        installment_en: '- Installment over 12 Months without interest',
        payment_ar: 'قم بأختيار وسيلة الدفع سهولة عند اختيار طريقة الدفع -',
        payment_en: '-Select payment method Souhoola at checkout',
      },
      {
        image: 'assets/images/contact-installment.png',
        alt: 'Contact',
        installment_ar: 'قسط على 36 شهر -',
        installment_en: '-Installment over 36 months',
        payment_ar: 'قم بأختيار وسيلة الدفع كونتكت عند اختيار طريقة الدفع -',
        payment_en: '-Select payment method Contact at checkout',
      },
      {
        image: 'assets/images/ABK-installment.png',
        alt: 'ABK',
        installment_ar: 'قسط على 12 شهر بدون فوائد-',
        installment_en: '-Installment over 12 months',
        payment_ar:
          'قم بأختيار الدفع تقسيط ببطاقة الأتمان عند اختيار طريقة الدفع -',
        payment_en:
          '-Select payment method Credit card installment at checkout',
      },
    ];
  }

  ngOnInit() {
    this.lang = localStorage.getItem('lang');
  }
}
